var map = {
	"./icon_playing.svg": 646,
	"./thumbnails/02_hero_desktop.jpg": 363,
	"./thumbnails/02_hero_mobile.jpg": 364,
	"./thumbnails/02_hero_tablet.jpg": 365,
	"./thumbnails/04_hero_desktop.jpg": 366,
	"./thumbnails/04_hero_mobile.jpg": 367,
	"./thumbnails/04_hero_tablet.jpg": 368,
	"./thumbnails/06_hero_desktop.jpg": 369,
	"./thumbnails/06_hero_mobile.jpg": 370,
	"./thumbnails/06_hero_tablet.jpg": 371,
	"./thumbnails/07_hero_desktop.jpg": 372,
	"./thumbnails/07_hero_mobile.jpg": 373,
	"./thumbnails/07_hero_tablet.jpg": 374,
	"./thumbnails/08_hero_desktop.jpg": 375,
	"./thumbnails/08_hero_mobile.jpg": 376,
	"./thumbnails/08_hero_tablet.jpg": 377,
	"./thumbnails/10_hero_desktop.jpg": 378,
	"./thumbnails/10_hero_mobile.jpg": 379,
	"./thumbnails/10_hero_tablet.jpg": 380,
	"./thumbnails/11b_hero_desktop.jpg": 381,
	"./thumbnails/11b_hero_mobile.jpg": 382,
	"./thumbnails/11b_hero_tablet.jpg": 383,
	"./thumbnails/12b_hero_desktop.jpg": 384,
	"./thumbnails/12b_hero_mobile.jpg": 385,
	"./thumbnails/12b_hero_tablet.jpg": 386,
	"./thumbnails/Corteva_Do_More_with_Less.jpg": 387,
	"./thumbnails/Corteva_From_Data_to_Decision.jpg": 388,
	"./thumbnails/Tanzania-Queen-and-Son-small.jpg": 389,
	"./thumbnails/Thailand.jpg": 390,
	"./thumbnails/artOfPrecision-desktop.jpg": 391,
	"./thumbnails/brazil_old_pastures.jpg": 392,
	"./thumbnails/cracking-the-code.jpg": 393,
	"./thumbnails/farmingWithNoRain-desktop.jpg": 394,
	"./thumbnails/foodByPrescription-desktop.jpg": 395,
	"./thumbnails/howTheWorldGrow-desktop.jpg": 396,
	"./thumbnails/seeds-of-change-desktop.jpg": 397,
	"./thumbnails/silicon-farm-thumbnail.jpg": 398,
	"./videoposters/Corteva_Do_More_with_Less-desktop.jpg": 399,
	"./videoposters/Corteva_Do_More_with_Less-mobile.jpg": 400,
	"./videoposters/Corteva_Do_More_with_Less-tablet.jpg": 401,
	"./videoposters/Corteva_From_Data_to_Decision-desktop.jpg": 402,
	"./videoposters/Corteva_From_Data_to_Decision-mobile.jpg": 403,
	"./videoposters/Corteva_From_Data_to_Decision-tablet.jpg": 404,
	"./videoposters/Corteva_How_the_world_grows_TMT-CORT003-120-desktop.jpg": 405,
	"./videoposters/Corteva_How_the_world_grows_TMT-CORT003-120-mobile.jpg": 406,
	"./videoposters/Corteva_How_the_world_grows_TMT-CORT003-120-tablet.jpg": 407,
	"./videoposters/Farming_where_it_doesnt_rain_tablet.png": 408,
	"./videoposters/TMT-CORT010-120-desktop.jpg": 409,
	"./videoposters/TMT-CORT010-120-mobile.jpg": 410,
	"./videoposters/TMT-CORT010-120-tablet.jpg": 411,
	"./videoposters/Tanzania-Queen-and-Son-small-desktop.jpg": 412,
	"./videoposters/Tanzania-Queen-and-Son-small-mobile.jpg": 413,
	"./videoposters/Tanzania-Queen-and-Son-small-tablet.jpg": 414,
	"./videoposters/Thailand-desktop.jpg": 415,
	"./videoposters/Thailand-mobile.jpg": 416,
	"./videoposters/Thailand-tablet.jpg": 417,
	"./videoposters/art-of-precision.jpg": 418,
	"./videoposters/brasil_new_pastures-desktop.jpg": 419,
	"./videoposters/brasil_new_pastures-mobile.jpg": 420,
	"./videoposters/brasil_new_pastures-tablet.jpg": 421,
	"./videoposters/cracking-the-code-desktop.jpg": 422,
	"./videoposters/cracking-the-code-mobile.jpg": 423,
	"./videoposters/cracking-the-code-tablet.jpg": 424,
	"./videoposters/seeds-of-change-desktop.jpg": 425,
	"./videoposters/seeds-of-change-mobile.jpg": 426,
	"./videoposters/seeds-of-change-tablet.jpg": 427,
	"./videoposters/silicon-farm-poster-desktop.jpg": 428,
	"./videoposters/silicon-farm-poster-mobile.jpg": 429,
	"./videoposters/silicon-farm-poster-tablet.jpg": 430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 645;